import {ScriptKocStoreModel} from './scriptKoc';

export * from './scriptKoc';

export interface TalentStoreModel {
    /** 稿件互动明细 */
    scriptKoc: ScriptKocStoreModel;
}
